// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"0baaffba","320":"64c649c5"}[chunkId] + ".chunk.css";
};